// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"410":"6d43e260","453":"53313f1b","575":"0ca0fca1","744":"ebc6570b","801":"3e9ea756","981":"87c08b23"}[chunkId] + ".chunk.js";
};